import * as Collapsible from '@studio/design-system/collapsible';
import type { ReactElement } from 'react';
import type { AdvancedProps } from './types.js';
import { usePrefState } from '#~/preferences/hooks.js';

/** `<Advanced>` component. */
export const Advanced = ({
  children,
  defaultOpen = true,
  slug,
  ...props
}: AdvancedProps): ReactElement => {
  const [isOpen, setOpen] = usePrefState(slug, defaultOpen);

  return (
    <div {...props}>
      <Collapsible.Root onChange={setOpen} open={isOpen}>
        <Collapsible.Trigger className='mb-16 py-8'>Advanced settings</Collapsible.Trigger>
        <Collapsible.Content>
          {/* Adds margin to prevent focus rings from being clipped. */}
          <div className='m-4 mt-0'>{children}</div>
        </Collapsible.Content>
      </Collapsible.Root>
    </div>
  );
};
